export default __webpack_public_path__ + "static/media/flyover-video-bg.6a5499d2.svg";